import React, { useEffect } from "react";
import { Route, Switch } from "react-router-dom";
import * as source from "sources/books/usersGroups";
import List from "./list";
import Show from "./show";

export default function UsersGroups(props) {
    useEffect(() => {
        return () => props.clearParams("users-groups");
    }, []);

    const { match, location, history } = props;
    const back = () => history.push(match.path);
    return (
        <div className="page-content">
            <Switch location={location}>
                <Route
                    path={`${match.path}/:id`}
                    render={(rest) => <Show {...rest} transition="full" title="Группа" back={back} source={source} />}
                />
                <Route
                    exact
                    path={match.path}
                    render={() => (
                        <List
                            {...props}
                            transition="full"
                            createBtnText="Создать группу"
                            title="Группы пользователей"
                            nofilter
                            source={source}
                        />
                    )}
                />
            </Switch>
        </div>
    );
}
